import React from "react";

const Activity = () => {
  return (
    <div className="container mt-4">
      <h4>Activity</h4>

      <div className="card p-3">
        <table className="table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Type</th>
              <th>Due</th>
              <th>Owner</th>
            </tr>
          </thead>

          <tbody>
            {[1,2,3].map(i => (
              <tr key={i}>
                <td>Meeting</td>
                <td><span className="badge bg-primary">Call</span></td>
                <td>14 Jan</td>
                <td>Henry</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Activity;